<template>
  <div>
    <v-dialog name="dialog" />
    <div class="admin_title">消息记录</div>
    <!--右侧内容-->
    <div style="padding: 0 10px;">
      <div class="gj_top_class" style="margin-bottom: 10px;">
      </div>
      <div class="gj_list" style="min-height:670px;">
        <el-table v-if="tableData.data && tableData.data.length > 0"
                  :data="tableData.data" stripe border @selection-change="updateSelected"
                  style="width: 100%">
          <el-table-column
            prop="title" label="标题" sortable>
          </el-table-column>
          <el-table-column
            prop="content" label="内容" sortable>
          </el-table-column>
          <el-table-column
            prop="updateDate" label="发送时间">
          </el-table-column>
          <el-table-column label="操作" width="250">
            <template slot-scope="scope">
              <el-button @click="del(scope.row)"
                         size="mini"
                         type="danger">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <h5 class="none_ts" v-if="tableData.data.length == '0'">
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
      </div>
    </div>
    <!--/右侧内容-->
    <div class="zy_list_bottom mtf30">
      <dl>
        <dt v-if="tableData.data.length > 0"><!--<input id="sel_1" onchange="selectAll()" type="checkbox" value="1" style="opacity: 1;"/> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/> <input name="" type="button" value="删除所选"  class="btn_zy_bottom" />-->共{{cnt}}条记录</dt>
        <dd v-if="tableData.data.length >0">
          <paginate v-if="pages > 0" :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text></paginate>
        </dd>
      </dl>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
  import api from '@/api/index'
  import config from '@/config/index'
  import utils from '@/utils'
  import Paginate from 'vuejs-paginate'
  import { getCookie } from "@/store/cookies";
  import { mapState } from 'vuex'
  export default {
    components: { Paginate },
    mounted () {
      this.search(this.filters)
    },
    data () {
      return {
        lists: [],
        selected: [], // 选择的列表
        filters: {
          pageNo: 1,
          pageSize: 7,
          delFlag: '0'
        },
        pages: 0,
        cnt: 0,
        tableData: {
          data: []
        }
      }
    },
    computed: {
      ...mapState('auth', ['user'])
    },
    methods: {
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      updateSelected (val) {
        this.selected = val
      },
      to (path, id) {
        this.$router.push({
          name: path,
          params: {
            id: id
          }
        })
      },
      clickCallback (pageNum)  {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      del (item) {
        if (item) {
          var that = this
          this.confirmBox({
            title: '删除',
            text: '确认删除吗？',
            yes: function () {
              api.get(config.messageApiPath, '/station/deleteStationMessage', {id: item.id}, function (r) { // 正常
                that.$toasted.show('删除成功')
                that.$modal.hide('dialog')
                that.search(that.filters)
              })
            }
          })
        }
      },
      search (filters) {
        if (!filters) { filters = {} }
        var that = this
        api.post(config.messageApiPath, '/station/getStationMessageList', filters, function (r) { // 正常
          that.pages = Math.ceil(r.cntData / that.filters.pageSize)
          that.cnt = r.cntData
          if (r.data) {
            that.tableData.data = r.data
          } else {
            that.tableData.data = []
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/page/byl/org/msg/list.vue